// @helpers
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { tagFiocDocumentationSuccess } = require('utilities/taggingInfo/fiocTags');

// @constants
const actionTypes = require('../constants/actionTypes');
const { FRONT_DNI, BACK_DNI, PASSPORT} = require('../constants/index');

const getFiocStatusInProgress = () => ({
    type: actionTypes.GET_FIOC_STATUS_IN_PROGRESS
});

const getFiocStatusSuccess = (payload = {}) => ({
    type: actionTypes.GET_FIOC_STATUS_SUCCESS,
    payload
});

const getFiocStatusError = (payload = {}) => ({
    type: actionTypes.GET_FIOC_STATUS_ERROR,
    payload
});

const getFiocStatus = () => (dispatch) => {
    dispatch(getFiocStatusInProgress());
    return APIGet({
        dispatch,
        endpoint: 'fiocStatus'
    })
        .then(response => {
            dispatch(getFiocStatusSuccess(response));
            return response;
        })
        .catch(error => {
            dispatch(getFiocStatusError(error));
        });
};

const fiocStatusReset = () => ({
    type: actionTypes.FIOC_STATUS_RESET
});

const addFile = fileState => ({
    type: actionTypes.FIOC_ADD_FILE,
    payload: fileState
});

const removeFile = fileState => ({
    type: actionTypes.FIOC_REMOVE_FILE,
    payload: fileState
});

const removeDocumentListError = () => ({
    type: actionTypes.REMOVE_DOCUMENT_LIST_ERROR
});

const uploadFIOCDocumentsRequest = () => ({
    type: actionTypes.FIOC_UPLOAD_DOCUMENTS_REQUEST
})

const uploadFIOCDocumentsSuccess = (response) => ({
    type: actionTypes.FIOC_UPLOAD_DOCUMENTS_SUCCESS,
    payload: {
        response
    }
})

const uploadFIOCDocumentsError = (error) => ({
    type: actionTypes.FIOC_UPLOAD_DOCUMENTS_ERROR,
    payload: {
        error
    }
})

const uploadFIOCDocuments = (files) => dispatch => {

    const requestData1 = [];
    files.forEach((file) => {
        const documentCode = file["name"].split("-")[1];
        const imageType = file["name"].split("-")[2];
        const data = requestData1.find(function (data) { return data.tipoDocumento === documentCode });
        if (data && (imageType === FRONT_DNI || imageType === BACK_DNI || imageType === PASSPORT)) {
            data.documentList.push({ "docBase64": file.data.base64 })
        } else {
            requestData1.push({
                "canalLlamada": "1",
                "tipoDocumento": documentCode,
                "documentList": [{ "docBase64": file.data.base64 }]
            })
        }
    });

    const requestData = { query: requestData1 };
    dispatch(uploadFIOCDocumentsRequest())

    return APIPost({
        dispatch,
        endpoint: 'uploadFiocDocuments',
        params: requestData,
        contentType: false
    }).then(response => {
        tagFiocDocumentationSuccess();
        dispatch(uploadFIOCDocumentsSuccess(response.result));
    }).catch((error) => {
        dispatch(uploadFIOCDocumentsError(error));
    });

}

const parseFiocData = ({ fioc, workFor, profession, companyName, activity }) => (dispatch, getState) => {
    const parsedWorkFor = parseWorkFor(workFor, profession);

    const cnaeValues = getCnaeValues(getState());
    const { cnaeInput, cnaeYesOrNotInput } = parseCnae({ cnaeValues, workFor, profession });

    const parsedTerceraDirectiva = parseTerceraDirectiva(fioc, parsedWorkFor.value);

    const parsedProfession = parseProfession(profession, parsedWorkFor.value);
    const parsedActivity = parseActivity(activity);

    const parsedCompanyName = parseCompanyName(companyName);

    return [
        ...parsedTerceraDirectiva,
        parsedWorkFor,
        parsedProfession,
        parsedCompanyName,
        parsedActivity,
        cnaeYesOrNotInput,
        cnaeInput,
    ].flat(Infinity).filter(item => item?.position >= 0);
};

const parseWorkFor = (workFor, profession) => {
    const numberWorkFor = parseInt(workFor);
    const valueByProfession = {
        X200B: 2,
        PJ00: 3,
        X300B: 4,
        X200A: 4,
        X300A: 4,
    }

    const value = numberWorkFor === 1 || numberWorkFor === 2 ?  numberWorkFor - 1 : valueByProfession[profession];

    return { id: 'fioc_ocupation', position: 4, value };
}

const parseProfession = (profession, workFor) => {
    const valueByProfession = {
        X300B: 0,
        X200A: 1,
        X300A: 2,
    }

    return workFor !== 4 ? { id: 'fioc_profession_category', position: 0, value: profession } : {
        id: 'your_job',
        position: 46,
        value: valueByProfession[profession]
    };
};

const parseActivity = activity => ({ id: 'fioc_profession', position: 7, value: activity });

const parseCompanyName = companyName => ({ id: 'company_name', position: 14, value: companyName });

const getCnaeValues = state => state.contracts.get('professionCnaeUncategorized').toJS();

const parseCnae = ({ cnaeValues, workFor, profession }) => {
  const cnaeValueOfProfession =
    workFor === 0 ? cnaeValues.find(({ code }) => code === profession) : {};
  const cnaeYesOrNotInput = cnaeValueOfProfession.code && {
    id: 'fioc_cnae',
    position: 3,
    value: 1,
  };
  const cnaeInput = { id: 'profession_cnae', position: 12, value: cnaeValueOfProfession.code };

  return { cnaeYesOrNotInput, cnaeInput };
};

const parseIncomeOrigin = (incomeInfo) => {
  const allIncomeOriginValues = incomeInfo.replace('#', '').split('$').filter(value => value && value !== ' ');
    const positionAndIdByIncomeOrigin = {
        252: { id: 'income_origin_benefits', position: 49 },
        253: { id: 'income_origin_family_help', position: 50 },
        254: { id: 'income_origin_financial_investments', position: 51 },
        255: { id: 'income_origin_investment_property', position: 52 },
    };

    const incomeOrigin = allIncomeOriginValues.map(value => {
        const mapping = positionAndIdByIncomeOrigin[value.trim()];
        return mapping && { ...mapping, value: true}
    }).filter(Boolean);

    const tooltipDisabled = incomeOrigin.length > 0;

    incomeOrigin.push({ id: "income_origin_tooltip", position: 48, value: tooltipDisabled});

    return incomeOrigin;
}

const parseTerceraDirectiva = (terceraDirectiva, workFor) => {
    const cleanDirectiva = terceraDirectiva.split('#').filter(value => value);

    const parsedCapital = parseCapital(cleanDirectiva[1]);
    const parsedAnnualIncome = parseAnnualIncome(cleanDirectiva[2]);
    const parsedPublicCharges = parsePublicCharges(cleanDirectiva[3]);
    const publicChargesWasAYes = parsedPublicCharges.find(({ _, value }) => value === 1);
    const parsedIncome = publicChargesWasAYes || workFor === 2 && parseIncome(cleanDirectiva[4]);
    const parsedThirdParty = parseThirdParty(cleanDirectiva[5]);
    const parsedPurpose = parsePurpose(cleanDirectiva[6], workFor);
    const proposeWasNotManageDaily = parsedPurpose.value !== 1;
    const parsedOperations = proposeWasNotManageDaily && parseOperations(cleanDirectiva[7]);
    const parsedIncome2 = (!publicChargesWasAYes && proposeWasNotManageDaily) && parseIncome(cleanDirectiva[8]);
    const parsedIncomeOrigin = cleanDirectiva[12] ? parseIncomeOrigin(cleanDirectiva[12]) : '';

    return [
        parsedAnnualIncome,
        parsedIncome,
        parsedThirdParty,
        parsedPurpose,
        parsedIncome2,
        parsedCapital,
        parsedPublicCharges,
        parsedOperations,
        parsedIncomeOrigin,
    ];
};

const parseCapital = (capital) => {
    const allCapitalValues = capital.split('$').filter(value => value && value !== ' ');
    const positionAndIdByCapital = {
        66: { id: 'capital_work', position: 16 },
        67: { id: 'capital_activities', position: 17 },
        68: { id: 'capital_heritage', position: 18 },
        69: { id: 'capital_business', position: 19 },
        70: { id: 'capital_realState', position: 20 },
        104: { id: 'capital_gambling', position: 21 },
    };

    return allCapitalValues.map(value => {
        if (!positionAndIdByCapital[value.trim()]) {
            return [
                { id: 'capital_other', position: 22, value: true },
                { id: 'capital_description', position: 23, value },
            ];
        }

        const { id, position } = positionAndIdByCapital[value.trim()];

        return { id, position, value: true };
    });
};

const parseAnnualIncome = (annualIncome) => {
    return { id: 'incomes_annual', position: 25, value: annualIncome };
};

const parsePublicCharges = (publicCharges) => {
    if (publicCharges.includes('SI')) {
        const [_, publicChargesText] = publicCharges.split('$');

        return [
            { id: 'has_pep', position: 5, value: 1 },
            { id: 'has_pep_details', position: 6, value: publicChargesText }
        ];
    }

    return [{ id: 'has_pep', position: 5, value: 0 }];
};

const parseIncome = (income) => {
    const allIncomeValues = income.split('$').filter(value => value);
    const positionAndIdByIncome = {
        76: { id: 'income_work', position: 27 },
        77: { id: 'income_activities', position: 28 },
        78: { id: 'income_business', position: 29 },
        79: { id: 'income_realState', position: 30 },
    };

    return allIncomeValues.map(value => {
        if (!positionAndIdByIncome[value.trim()]) {
            return value !== ' ' && [
                { id: 'income_other', position: 31, value: true },
                { id: 'income_description', position: 32, value }
            ];
        }

        const { id, position } = positionAndIdByIncome[value.trim()]

        return { id, position, value: true };
    });
};

const parseThirdParty = (thirdParty) => {
    return { id: 'operations_account', position: 26, value: thirdParty === 81 ? 1 : 0 };
};

const parsePurpose = (purpose, workFor) => {
    const { id, position } = workFor === 0 ? { id: 'account_use', position: 33 } : { id: 'account_use_2', position: 34 };
    const valueByPurpose = {
        83: 1,
        84: 2,
        85: 3,
    };

    return { id, position, value: valueByPurpose[purpose] };
};

const parseOperations = (operations) => {
    const allOperationsValues = operations.split('$').filter(value => value);
    const positionAndIdByOperation = {
        105: { id: 'operations_dangerous_countries', position: 36 },
        106: { id: 'checks_holder', position: 37 },
        86: { id: 'checks_traveler', position: 38 },
        87: { id: 'delivery_or_cash_withdrawals', position: 39 },
        88: { id: 'buying_and_selling_foreing_banknotes', position: 40 },
        89: { id: 'payment_orders_or_collection_abroad', position: 41 },
        90: { id: 'foreing_trade_operations', position: 42 },
        91: { id: 'none_of_the_above', position: 43 },
    };

    return allOperationsValues.map(value => {
        const { id, position } = positionAndIdByOperation[value.trim()]

        return { id, position, value: true };
    });
};

module.exports = {
    fiocStatusReset,
    getFiocStatus,
    addFile,
    removeFile,
    removeDocumentListError,
    uploadFIOCDocuments,
    parseFiocData
};
